import React from 'react'
import { Link } from 'react-router-dom'

const StatusLayout = ({ title, iconBg, iconColor, icon, heading, orderRef, message, actionLabel, actionTo }) => (
  <div className="min-h-screen bg-[#fde1ff] text-gray-900">
    <section className="border-b border-gray-200 bg-gradient-to-br from-violet-700 via-violet-800 to-indigo-900 px-4 py-14 text-white sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <p className="text-sm font-semibold uppercase tracking-widest text-violet-200">Tagers Shoppe</p>
        <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">{title}</h1>
      </div>
    </section>
    <section className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="rounded-xl border border-gray-200 bg-white p-12 text-center shadow-sm">
        <div className={`mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full ${iconBg}`}>
          {icon}
        </div>
        <h2 className="text-2xl font-bold text-gray-900">{heading}</h2>
        {orderRef && (
          <p className={`mt-3 text-sm font-mono inline-block px-4 py-2 rounded-lg border ${iconColor}`}>
            Order reference: {orderRef}
          </p>
        )}
        <p className="mt-3 text-gray-500">{message}</p>
        <Link
          to={actionTo}
          className="mt-6 inline-block rounded-lg bg-violet-800 px-6 py-3 text-sm font-semibold text-white hover:bg-violet-500"
        >
          {actionLabel}
        </Link>
      </div>
    </section>
  </div>
)

export const PaymentSuccess = ({ orderRef }) => (
  <StatusLayout
    title="Payment Successful"
    iconBg="bg-emerald-100"
    iconColor="text-violet-700 bg-violet-50 border-violet-200"
    icon={
      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-emerald-600" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
      </svg>
    }
    heading="Thank you for your order!"
    orderRef={orderRef}
    message="Your payment has been confirmed. A confirmation email has been sent to your inbox."
    actionLabel="Continue Shopping"
    actionTo="/"
  />
)

export const PaymentCancelled = ({ orderRef }) => (
  <StatusLayout
    title="Payment Cancelled"
    iconBg="bg-amber-100"
    iconColor="text-amber-700 bg-amber-50 border-amber-200"
    icon={
      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-amber-600" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    }
    heading="Payment Cancelled"
    orderRef={orderRef}
    message="Your payment was not completed. Your cart items are still saved."
    actionLabel="Return to Cart"
    actionTo="/Cart"
  />
)

export const PaymentFailed = ({ orderRef }) => (
  <StatusLayout
    title="Payment Failed"
    iconBg="bg-red-100"
    iconColor="text-red-700 bg-red-50 border-red-200"
    icon={
      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-600" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    }
    heading="Payment Failed"
    orderRef={orderRef}
    message="Something went wrong with your payment. Please try again."
    actionLabel="Return to Cart"
    actionTo="/Checkout"
  />
)
